import Nullable from "@data-force/app/interfaces/nullable";
import {
    ChangeActiveTaskAction,
    CompleteIntakeAction,
    GetActiveTaskDetailsAction,
    GetTaskListAction,
    ResetTaskDataAction,
    SaveActiveTaskAction,
    SaveCompletedAction,
    SaveTaskSuccessAction,
    SelectTaskInWizardAction,
    SetActiveTaskByIdAction,
    SetTaskListAction,
    SetTaskMaskDataAction,
    StartTaskWizardAction,
    UpdateActiveTaskAction,
    UpdateActiveTaskPrivatesAction,
    UpdateTaskEntityByIdAction,
    UpdateTaskStatusAction,
} from "../../interfaces/store/actions/task";
import {
    CHANGE_ACTIVE_TASK,
    COMPLETE_INTAKE,
    GET_ACTIVE_TASK_DETAILS,
    GET_TASK_LIST,
    RESET_TASK_DATA,
    SAVE_ACTIVE_TASK,
    SAVE_COMPLETED,
    SAVE_TASK_SUCCESS,
    SELECT_TASK_IN_WIZARD,
    SET_ACTIVE_TASK_BY_ID,
    SET_TASK_LIST,
    SET_TASK_MASK_DATA,
    START_TASK_WIZARD,
    UPDATE_ACTIVE_TASK,
    UPDATE_ACTIVE_TASK_PRIVATES,
    UPDATE_TASK_ENTITY_BY_ID,
    UPDATE_TASK_STATUS,
} from "./availableActions";
import {
    ActiveTaskPrivates,
    ChangeActiveTask,
    CompleteIntakePayload,
    GetTaskListPayload,
    Task,
    TaskEntity,
    TaskMaskData,
    UpdateActiveTask,
} from "../../interfaces/store/actions/payload/task";

export const completeIntake = (payload: CompleteIntakePayload): CompleteIntakeAction => ({
    type: COMPLETE_INTAKE,
    payload,
});

export const getTaskList = (payload: GetTaskListPayload): GetTaskListAction => ({
    type: GET_TASK_LIST,
    payload,
});

export const setTaskList = (payload: TaskEntity[]): SetTaskListAction => ({
    type: SET_TASK_LIST,
    payload,
});

export const getActiveTaskDetails = (): GetActiveTaskDetailsAction => ({
    type: GET_ACTIVE_TASK_DETAILS,
});

export const setActiveTaskById = (payload: string): SetActiveTaskByIdAction => ({
    type: SET_ACTIVE_TASK_BY_ID,
    payload,
});

export const changeActiveTask = (payload: ChangeActiveTask): ChangeActiveTaskAction => ({
    type: CHANGE_ACTIVE_TASK,
    payload,
});

export const updateActiveTaskPrivates = (payload: ActiveTaskPrivates): UpdateActiveTaskPrivatesAction => ({
    type: UPDATE_ACTIVE_TASK_PRIVATES,
    payload,
});

export const saveActiveTask = (payload: Task): SaveActiveTaskAction => ({
    type: SAVE_ACTIVE_TASK,
    payload,
});

export const updateActiveTask = (payload: UpdateActiveTask): UpdateActiveTaskAction => ({
    type: UPDATE_ACTIVE_TASK,
    payload,
});

export const updateTaskEntityById = (payload: TaskEntity): UpdateTaskEntityByIdAction => ({
    type: UPDATE_TASK_ENTITY_BY_ID,
    payload,
});

export const saveTaskSuccess = (payload: Task): SaveTaskSuccessAction => ({
    type: SAVE_TASK_SUCCESS,
    payload,
});

export const saveCompleted = (): SaveCompletedAction => ({
    type: SAVE_COMPLETED,
});

export const startTaskWizard = (): StartTaskWizardAction => ({
    type: START_TASK_WIZARD,
});

export const setTaskMaskData = (payload: TaskMaskData): SetTaskMaskDataAction => ({
    type: SET_TASK_MASK_DATA,
    payload,
});

export const resetTaskData = (): ResetTaskDataAction => ({
    type: RESET_TASK_DATA,
});

export const selectTaskInWizard = (payload: string): SelectTaskInWizardAction => ({
    type: SELECT_TASK_IN_WIZARD,
    payload,
});

export const updateTaskStatus = (payload: Nullable<TaskEntity>): UpdateTaskStatusAction => ({
    type: UPDATE_TASK_STATUS,
    payload,
});
